// extracted by mini-css-extract-plugin
export default {"title":"Search_title__+0tSj","search-input":"Search_search-input__k-A5w"};